import {css} from '@emotion/css';
import {Breakpoints, mq} from '@fo/shared/styles/mixins';
import {colours, spacing} from '@fo/shared/styles/variables';

const styles = {
  calculatorResults: css`
    label: calculatorResults;
    background-color: ${colours.background.SECTION};
    border-radius: 10px;
    height: 100%;

    ${mq(Breakpoints.TABLET)} {
      background-color: ${colours.general.WHITE};
    }
  `,
  // @todo: remove important once accordion is refactored to emotion
  collapseButton: (hide: boolean): string => css`
    label: calculatorResults__collapseButton;

    padding: ${spacing.XXS} !important;
    margin-bottom: 0 !important;
    ${hide ? 'display: none !important;' : ''};
  `,
  wrapper: css`
    label: calculatorResults__wrapper;
    height: 100%;
  `,
  wrapperInner: css`
    label: calculatorResults__wrapperInner;
    display: flex;
    flex-direction: column;

    ${mq(Breakpoints.TABLET)} {
      height: 100% !important;
    }
  `,
};

export default styles;
